export default "__VITE_ASSET__CjKDNqLu__"